import { Button } from "@mui/joy";
import { useTranslation } from "react-i18next";
import { useRecoilState } from "recoil";
import { deviceAtom } from "recoil/deviceAtom";
import { sendMessage } from "utils/webview";

export default function RequestPushNotificationButton({
  disabled,
}: {
  disabled: boolean;
}) {
  const { t: t_ui } = useTranslation("translation", {
    keyPrefix: "ui",
  });

  const [device, setDeviceState] = useRecoilState(deviceAtom);
  const isGranted = device.pushNotificationStatus === "granted";

  return (
    <Button
      onClick={() => {
        sendMessage(
          JSON.stringify({
            event: "request_pushNotification",
          })
        );
        setDeviceState((user) => ({
          ...user,
          pushNotificationStatus: "not set",
        }));
      }}
      disabled={isGranted || disabled}
    >
      {t_ui(!isGranted ? "알림 허용하기" : "알림 허용됨")}
    </Button>
  );
}
